import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadTemplate } from '../bulk/BulkModification.graphql';
import client from '@/apolloClient';
import type { TemplateKey } from '@/gql/enums';
import { error as showErrorNotification } from '@/utils/notifications/actions';

const useDownloadTemplate = () => {
    const { t } = useTranslation('performanceResult');

    const downloadTemplate = useCallback(
        async (key: TemplateKey) => {
            try {
                const { data: templateData } = await client.query({
                    query: DownloadTemplate,
                    variables: { filter: { key } },
                });

                if (templateData?.templateFile?.__typename === 'ErrorResponse') {
                    const errorResponse = templateData.templateFile;
                    const specificErrorField = errorResponse.fields?.find(f => f.message);
                    const errorMessage = specificErrorField?.message || t('bulk.downloadTemplateErrorDesc');
                    showErrorNotification({
                        message: t('bulk.downloadTemplateErrorTitle'),
                        description: errorMessage,
                    });
                } else {
                    const file = templateData?.templateFile.result.file;
                    if (file?.url) {
                        const link = document.createElement('a');
                        link.href = file.url as string;
                        link.download = (file.filename as string) || 'template.xlsx';
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                }
            } catch (error) {
                console.error('Error downloading template:', error);
                throw error;
            }
        },
        [t]
    );

    return { downloadTemplate };
};

export default useDownloadTemplate;
